var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.533,
    height: 33.533,
    viewBox: "0 0 33.533 33.533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.766,
    cy: 16.766,
    r: 16.766,
    opacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.729,22.529a1.917,1.917,0,0,0,1.907-1.915H11.822A1.917,1.917,0,0,0,13.729,22.529Zm6.2-5.746V11.515a6.207,6.207,0,0,0-4.767-6.034v-.67a1.43,1.43,0,1,0-2.86,0v.67a6.207,6.207,0,0,0-4.767,6.034v5.267L5.625,18.7v.958H21.832V18.7Z",
    transform: "translate(3.375 3.625)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.fd139733c860e271b870056a97286592.svg";
export { ForwardRef as ReactComponent };